import { FC } from 'react';
import ModalityCard, {
  CardType,
} from 'react-components/modalities/modality-card/modality-card';
import styles from './cards.module.scss';
import openNew from 'assets/images/icons/ic_open_new.svg';

type Props = {
  href?: string;
  onClick?: () => void;
  shouldGrow?: boolean;
  type?: keyof typeof CardType;
};

const WorkLifeServiceCard: FC<Props> = ({
  onClick,
  href,
  shouldGrow,
  type,
}: Props) => {
  return (
    <ModalityCard
      title={polyglot.t('online_booking.modalities.life_services.title')}
      info={polyglot.t('online_booking.modalities.life_services.info')}
      shouldGrow={shouldGrow}
      type={type}
    >
      {/* WB-15534 Business requirement removing noreferrer */}
      {/* eslint-disable-next-line react/jsx-no-target-blank */}
      <a
        href={href}
        target='_blank'
        rel='noopener'
        onClick={onClick}
        className={styles['ghost-btn']}
      >
        {polyglot.t('online_booking.modalities.life_services.cta')}
        <img alt='' src={openNew} />
      </a>
    </ModalityCard>
  );
};

export default WorkLifeServiceCard;
